import React from 'react'
import { Box } from 'rebass'
import styled from 'styled-components'
import Title from './titles/Title'

const ModalWrapper = styled(Box)`
  z-index: 2;
  background-color: #2c3037;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ModalBackground = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
`

const ModalHeader = styled(Box)`
  padding: 8px;
  border-bottom: 1px solid #dbd9da !important;
  background-color: #f8f9f9;
  border-radius: 3px 3px 0 0;
  color: #606060;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  z-index: 3;
  h3 {
    text-align: center;
    margin: 0;
    font-weight: 600;
  }
`

const ModalPosition = styled(Box)`
  background-color: white;
  margin: auto;
  border-radius: 4px;
  border: 1px solid #e9eaeb;
  z-index: 101;
  max-width: 100%;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  min-width: 220px;
`

const ModalContent = styled(Box)`
  width: 600px;
  max-width: 100%;
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  outline: 0;
  display: flex;
  flex-direction: column;
`

const ModalBody = styled(Box)`
  -webkit-overflow-scrolling: touch;
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
`

const CloseButton = styled(Box)`
  font-size: 1.2em;
  margin: -15px -10px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.1s;
  &:hover {
    color: black;
  }
`

export default class Modal extends React.Component {
  modalBackgroundRef = React.createRef()

  render () {
    return (
      <>
        <ModalWrapper id='modal-wrapper' style={this.props.modalWrapperStyle || {}}>
          <ModalBackground
            className='modal-background'
            ref={this.modalBackgroundRef}
            onClick={this.handleClickWrapper}
          />
          <ModalPosition className='modal-position'>
            <ModalContent id='modal' style={this.props.modalStyle || {}}>
              <ModalHeader className='modal-header' style={this.props.modalHeaderStyle || {}}>
                <div>{this.props.headerLeft}</div>
                <Title>{this.props.header}</Title>
                <div>
                  {this.props.headerRight
                    ? this.props.headerRight
                    : !this.props.hideCloseButton && (
                      <CloseButton className='modal-close zen-icon_ic_s-canceled' onClick={this.props.close} />
                    )}
                </div>
              </ModalHeader>
              <ModalBody className={`modal-body ${this.props.className || ''}`} style={this.props.modalBodyStyle || {}}>
                {this.props.children}
              </ModalBody>
              {!!this.props.footer && <div className='modal-footer'>{this.props.footer}</div>}
            </ModalContent>
          </ModalPosition>
        </ModalWrapper>
        <style global jsx>{`
          ${this.props.projectStyles}
        `}</style>
      </>
    )
  }
  handleClickWrapper = e => {
    if (!this.props.preventBackgroundClose && e.target === this.modalBackgroundRef.current) {
      this.props.close()
    }
  }
}
